var render = function render(){var _vm=this,_c=_vm._self._c;return _c('post-login',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('v-col',{class:{ 'col-sm-10': _vm.$route.name !== 'Login' }},[_c('router-view',{key:_vm.$route.fullPath})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }